// @utility
import { setStorage, removeStorage } from "@utility/app/storage";
import alertText from "@utility/app/alertText";

// Services
import { apiServices } from "@core/services/appService";

// Redux
import { setStatusSpinner } from "@core/redux/actions/app/spinner";
import { setSnackbarData } from "@core/redux/actions/app/snackbar";
import { loadHomeData } from "@core/redux/actions/home/index";
import { setDataAlert } from "@core/redux/actions/app/alert";

const LOAD_DATA_DEPOSIT = 'app/deposit/LOAD_DATA_DEPOSIT';
const LOAD_BANK_CUSTOMER = 'app/deposit/LOAD_BANK_CUSTOMER';

function loadDataDeposit() {
    return dispatch => {
        apiServices({}, "get", "/customer/payment-v2/deposit/channel").then((data) => {
            const { code: statusCode, result } = data;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (statusCode === 200 || statusCode === 0) {
                if (result?.pay_src) {
                    setStorage("paySrc", result?.pay_src);
                }

                if (result?.pay_mode) {
                    setStorage("payMode", result?.pay_mode);
                }

                if (result?.pay_account?.account) {
                    setStorage("payAccount", JSON.stringify(result?.pay_account));
                }

                if (result?.pay_amount) {
                    setStorage("payAmount", result?.pay_amount);
                }

                if (result?.pay_time_out) {
                    setStorage("payTimeOut", result?.pay_time_out);
                }

                dispatch({
                    type: LOAD_DATA_DEPOSIT,
                    payload: {
                        items: result
                    }
                });

                if (data.result.mode === "pay") {
                    setStorage("processDeposit", 1);
                }
                else if (data.result.mode === "deposit") {
                    dispatch(loadBankCustomer());
                }
            }
        });
    }
}

function loadBankCustomer() {
    return dispatch => {
        apiServices({}, "get", "/customer/payment/deposit/bank/customer/select-list").then((data) => {
            const { code: statusCode, result } = data;

            if (statusCode === 200 || statusCode === 0) {
                dispatch({
                    type: LOAD_BANK_CUSTOMER,
                    payload: {
                        items: result
                    }
                });
            }
        });
    }
}

const clearStorage = () => {
    removeStorage("paySrc");
    removeStorage("payMode");
    removeStorage("payAccount");
    removeStorage("payTimeOut");
    removeStorage("payAmount");
    removeStorage("processDeposit");
    removeStorage("depositPromptPayTime");
    removeStorage("channelPaySelect");
};

function confirmDeposit(data, setMenuSelect, setProcessing, path = "/customer/payment/deposit/channel-v3") {
    return dispatch => {
        const {
            amount,
            bankId,
            channel,
            channelId,
            // channelMode
        } = data;

        let methodType = 4;
        let selectType = 1;

        if (channel === "promtpay" || channel === "qrcode") {
            methodType = 5;
            selectType = 3;
        }
        else if (channel === "truemoney") {
            methodType = 6;
            selectType = 2;
        }
        else if (channel === "bank") {
            methodType = 4;
        }
        else {
            methodType = 0;
        }

        const dataJson = {
            "amount": amount,
            "bankId": bankId,
            "method": methodType,
            channel,
            channelId,
            "select": selectType
        };

        clearStorage();
        dispatch(setStatusSpinner({ status: true, textProcess: null }));

        // apiServices(dataJson, "post", "/customer/payment-v2/deposit/submit").then((data) => {
        // "/customer/payment/deposit/channel-v3"
        apiServices(dataJson, "post", path).then((data) => {
            let snackbarJson = {};
            const { code: statusCode, result } = data;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (setProcessing) {
                setProcessing(false);
            }

            if (statusCode === 200 || statusCode === 0) {
                setMenuSelect(channel);
                dispatch(setDepositData(result));
                setStorage("processDeposit", 1);

                // if (methodType === 4) {
                //     setMenuSelect("pending");
                // }

                setStorage("paySrc", result?.pay_src);
                setStorage("payMode", result?.pay_mode);
                setStorage("payAccount", JSON.stringify(result?.pay_account));
                setStorage("payAmount", result?.pay_amount);
                setStorage("payTimeOut", result?.pay_time_out);
                removeStorage("goBack");

                if (result?.qrcode_time_out) {
                    let firstEventTimestamp = Date.now(result?.qrcode_time_out);
                    setStorage("depositPromptPayTime", firstEventTimestamp);
                }
                else {
                    let firstEventTimestamp = Date.now();
                    let timeStart = firstEventTimestamp + (5 * 60 * 1000);

                    setStorage("depositPromptPayTime", timeStart);
                }
            }
            // test
            else if (statusCode === 36 || statusCode === 79) {
                if (result?.swift_code) {
                    dispatch(setDataAlert({
                        type: "warning",
                        title: "แจ้งเตือน",
                        text: `สร้างรายการไม่สำเร็จ เนื่องจากไม่สามารถเชื่อมต่อกับผู้ให้บริการ (${result?.swift_code}) <div class="alertMessageError">** หมายเหตุ : ${result?.message} **</div>`,
                        action: true,
                        redirect: null,
                        show: true,
                        buttonText: "ตกลง"
                    }));
                }
                else {
                    snackbarJson = alertText(statusCode);
                    dispatch(setDataAlert({
                        type: snackbarJson.statusAlert,
                        title: snackbarJson.titleAlert,
                        text: snackbarJson.textAlert,
                        action: true,
                        redirect: null,
                        show: true,
                        buttonText: "ตกลง"
                    }));
                }
            }
            else {
                snackbarJson = alertText(statusCode);
                dispatch(setDataAlert({
                    type: snackbarJson.statusAlert,
                    title: snackbarJson.titleAlert,
                    text: snackbarJson.textAlert,
                    action: true,
                    redirect: null,
                    show: true,
                    buttonText: "ตกลง"
                }));
            }
        });
    }
}

function cancelDeposit(gotoPageForce, noProcess) {
    return dispatch => {
        dispatch(setStatusSpinner({ status: true, textProcess: null }));

        apiServices({}, "post", "/customer/payment-v2/deposit/cancel").then((data) => {
            const { code: statusCode } = data;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (statusCode === 200 || statusCode === 0) {
                dispatch(loadDataDeposit());
                // removeStorage("paySrc");
                // removeStorage("payMode");
                // removeStorage("payAccount");
                // removeStorage("payTimeOut");
                // removeStorage("processDeposit");
                // removeStorage("depositPromptPayTime");
                clearStorage();

                if (!noProcess) {
                    dispatch(setDataAlert({
                        type: "success",
                        title: "แจ้งเตือน",
                        text: "ยกเลิกรายการเติมเงินสำเร็จ !",
                        action: true,
                        redirect: null,
                        show: true,
                        buttonText: "ตกลง"
                    }));
                }

                removeStorage("goBack");

                if (gotoPageForce) {
                    gotoPageForce("/deposit");
                }
            }
            else if (statusCode !== 39 && statusCode !== 0) {
                let snackbarJson = alertText(statusCode);
                dispatch(setDataAlert({
                    type: snackbarJson.statusAlert,
                    title: snackbarJson.titleAlert,
                    text: snackbarJson.textAlert,
                    action: true,
                    redirect: null,
                    show: true,
                    buttonText: "ตกลง"
                }));
            }
        });
    }
}

function checkDeposit(setMenuSelect, checkTime, depositId, typePage) {
    return dispatch => {
        apiServices({ "id": depositId }, "post", "/customer/payment/deposit/check").then((data) => {
            const { code: statusCode } = data;

            if (statusCode === 200 || statusCode === 0) {
                switch (data.result.status) {
                    case 0:
                    case 1: break;
                    case 2:

                        if (typePage === "deposit") {
                            dispatch(setDataAlert({
                                type: "success",
                                title: "แจ้งเตือน",
                                text: "ทำรายการเติมเงินสำเร็จ !",
                                action: true,
                                redirect: null,
                                show: true,
                                buttonText: "ตกลง"
                            }));
                        }
                        else {
                            dispatch(setSnackbarData({
                                statusShow: true,
                                statusAlert: "success",
                                titleAlert: "แจ้งเตือน",
                                textAlert: "ทำรายการเติมเงินสำเร็จ !"
                            }));
                        }

                        dispatch(loadDataDeposit());
                        dispatch(loadHomeData());
                        clearInterval(checkTime);
                        clearStorage();
                        setMenuSelect("homeForce");
                        break;
                    case 3:
                        dispatch(loadDataDeposit());
                        clearInterval(checkTime);
                        clearStorage();
                        setMenuSelect("homeForce");

                        dispatch(setDataAlert({
                            type: "warning",
                            title: "แจ้งเตือน",
                            text: "ยกเลิกรายการเติมเงิน เนื่องจากมีเงื่อนไขบางอย่างไม่ถูกต้อง! กรุณาทำรายการใหม่อีกครั้ง",
                            action: true,
                            redirect: null,
                            show: true,
                            buttonText: "ตกลง"
                        }));

                        break;
                    default:
                        clearInterval(checkTime);
                        clearStorage();

                        // dispatch(setDataAlert({
                        //     type: "error",
                        //     title: "แจ้งเตือน",
                        //     text: "ทำรายการเติมเงินไม่สำเร็จ! กรุณาติดต่อแอดมิน",
                        //     action: true,
                        //     redirect: null,
                        //     show: true,
                        //     buttonText: "ตกลง"
                        // }));
                        break;
                }
            }
            else {
                let snackbarJson = alertText(statusCode);
                dispatch(setSnackbarData(snackbarJson));
            }
        });
    }
}

function confirmStep(data) {
    return dispatch => {
        const {
            td_id,
            promotion_status,
            promotion_condition_id
        } = data;

        let dataJson = {
            "td_id": td_id,
            "promotion_status": promotion_status,
            "promotion_condition_id": promotion_condition_id
        };

        dispatch(setStatusSpinner({ status: true, textProcess: null }));
        apiServices(dataJson, "post", "/customer/payment/deposit/confirm").then((data) => {
            const { code: statusCode, result } = data;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (statusCode === 200 || statusCode === 0) {
                dispatch(loadDataDeposit());

                if (result !== null) {
                    if (result?.status === 2) {
                        dispatch(setDataAlert({
                            type: "success",
                            title: "แจ้งเตือน",
                            text: "ทำรายการเติมเงินสำเร็จ !",
                            action: true,
                            redirect: null,
                            show: true,
                            buttonText: "ตกลง"
                        }));

                        removeStorage("processDeposit");
                    }
                }
            }
            else {
                let snackbarJson = alertText(statusCode);
                dispatch(setDataAlert({
                    type: snackbarJson.statusAlert,
                    title: snackbarJson.titleAlert,
                    text: snackbarJson.textAlert,
                    action: true,
                    redirect: null,
                    show: true,
                    buttonText: "ตกลง"
                }));
            }
        });
    }
}

function confirmPaySlip(data, onShow, setImageUpload, setImagePreview) {
    return dispatch => {
        dispatch(setStatusSpinner({ status: true, textProcess: null }));

        apiServices(data, "file", "/customer/payment-v2/deposit/slip").then((data) => {
            const { code: statusCode, message } = data;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (statusCode === 200 || statusCode === 0) {
                dispatch(loadDataDeposit());

                dispatch(setDataAlert({
                    type: "success",
                    title: "แจ้งเตือน",
                    text: "แนบรูปสลิปสำเร็จ !",
                    action: true,
                    redirect: null,
                    show: true,
                    buttonText: "ตกลง"
                }));

                if (onShow) {
                    onShow();
                }
            }
            else {
                if (setImageUpload) {
                    setImageUpload(null);
                }

                if (setImagePreview) {
                    setImagePreview(null);
                }

                if (statusCode === 99) {
                    dispatch(setDataAlert({
                        type: "warning",
                        title: "แจ้งเตือน",
                        text: message,
                        action: true,
                        redirect: null,
                        show: true,
                        buttonText: "ตกลง"
                    }));
                }
                else {
                    let snackbarJson = alertText(statusCode);
                    dispatch(setDataAlert({
                        type: snackbarJson.statusAlert,
                        title: snackbarJson.titleAlert,
                        text: snackbarJson.textAlert,
                        action: true,
                        redirect: null,
                        show: true,
                        buttonText: "ตกลง"
                    }));
                }
            }
        });
    }
}

function confirmCheckSlip(data, onShow) {
    return dispatch => {
        dispatch(setStatusSpinner({ status: true, textProcess: null }));

        apiServices(data, "file", "/customer/payment/deposit/verify-slip").then((data) => {
            const { code: statusCode, message } = data;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (statusCode === 200 || statusCode === 0) {
                dispatch(loadDataDeposit());

                dispatch(setDataAlert({
                    type: "success",
                    title: "แจ้งเตือน",
                    text: "แนบรูปสลิปสำเร็จ !",
                    action: true,
                    redirect: null,
                    show: true,
                    buttonText: "ตกลง"
                }));

                if (onShow) {
                    onShow();
                }
            }
            else {
                if (statusCode === 99) {
                    dispatch(setDataAlert({
                        type: "warning",
                        title: "แจ้งเตือน",
                        text: message,
                        action: true,
                        redirect: null,
                        show: true,
                        buttonText: "ตกลง"
                    }));
                }
                else {
                    let snackbarJson = alertText(statusCode);
                    dispatch(setDataAlert({
                        type: snackbarJson.statusAlert,
                        title: snackbarJson.titleAlert,
                        text: snackbarJson.textAlert,
                        action: true,
                        redirect: null,
                        show: true,
                        buttonText: "ตกลง"
                    }));
                }
            }
        });
    }
}

function setDepositData(data) {
    return {
        type: LOAD_DATA_DEPOSIT,
        payload: {
            items: data
        }
    }
}

export {
    LOAD_DATA_DEPOSIT,
    LOAD_BANK_CUSTOMER,
    loadDataDeposit,
    loadBankCustomer,
    setDepositData,
    confirmDeposit,
    cancelDeposit,
    checkDeposit,
    confirmStep,
    confirmPaySlip,
    confirmCheckSlip
}